import { render, staticRenderFns } from "./ImportEmendas.vue?vue&type=template&id=07325884"
import script from "./ImportEmendas.vue?vue&type=script&lang=js"
export * from "./ImportEmendas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports